import lodashGet from 'lodash/get';
import { BRIDGE_RESPONSE_CODE } from '../../interface/common';
import bridgeProxyConfigList from '../../config/config';
import { isElectron } from '@/config';
export class ForbiddenRetryInterceptor {
    constructor(interceptors) {
        const [, interceptor] = interceptors;
        interceptor.use({
            type: 'error',
            resolve: async (response) => response,
            reject(error) {
                const errorCode = lodashGet(error, 'code', -999);
                const enableRetry = [
                    () => errorCode === BRIDGE_RESPONSE_CODE.REJECT_BRIDGE_BY_CURPAGE,
                    () => {
                        if (isElectron()) {
                            return false;
                        }
                        return error.message.indexOf('BG_WIN_NOT_EXIST') !== -1;
                    },
                ].some(call => call());
                if (!enableRetry) {
                    throw error;
                }
                const namespace = lodashGet(error, 'config.namespace', '');
                const apiname = lodashGet(error, 'config.apiname', '');
                const args = lodashGet(error, 'config.args', '');
                const bridgeProxyConfig = bridgeProxyConfigList.find(item => item.namespace === namespace);
                if (!bridgeProxyConfig) {
                    throw error;
                }
                const apiTarget = bridgeProxyConfig.target();
                if (!apiTarget || typeof apiTarget[`_$${apiname}`] !== 'function') {
                    throw error;
                }
                return apiTarget[`_$${apiname}`](...args);
            },
        });
    }
    eject() { }
}
